import { render, staticRenderFns } from "./ImpuestosFilter.vue?vue&type=template&id=5c6c266a&scoped=true"
import script from "./ImpuestosFilter.vue?vue&type=script&lang=js"
export * from "./ImpuestosFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6c266a",
  null
  
)

export default component.exports